import React from 'react';
import List from 'housecall-ui/dist/DesignSystem/DataDisplay/List/List';
import ListItem from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItem';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import SearchIcon from 'housecall-ui/dist/IconsAndImages/Icons/Search';

interface EmptyResultsProps {
  primaryText: string;
  secondaryText: string;
}

const EmptyResults = ({ primaryText, secondaryText }: EmptyResultsProps) => (
  <List>
    <ListItem>
      <Grid container justify="center" alignItems="center" spacing={5}>
        <Grid item container justify="center" alignItems="center">
          <SearchIcon size="large" color="action" />
        </Grid>
        <Grid item container justify="center" alignItems="center">
          <Typography variant="body1" align="center" color="textSecondary">
            {primaryText}
          </Typography>
          <Typography variant="body1" align="center" color="textSecondary">
            {secondaryText}
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  </List>
);

export default EmptyResults;
